import { render, staticRenderFns } from "./VenkovniTeplota.vue?vue&type=template&id=b6cc367c&scoped=true&"
import script from "./VenkovniTeplota.vue?vue&type=script&lang=js&"
export * from "./VenkovniTeplota.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b6cc367c",
  null
  
)

export default component.exports